import { sendEvent } from '@civitime/game-server/lib/saga-tools/Data.effects'

export function * unlockQr(command) {
  yield sendEvent("QrUnlocked", {
    buildingType: command?.buildingType,
    moduleStep: command?.moduleStep,
    moduleId: command?.moduleId
  })
}